<template>
  <Pill
    link=""
    :text="$t('copy.homePage.mainLayout.usefulLinks.links.busSchedule')"
    @click-trigger="busScheduleWebView"
  />
</template>

<script>
import Pill from './Pill.vue';
import { Browser } from '@capacitor/browser';
import { FirebaseAnalytics } from '@/utils/firebase-analytics-wrapper';
import { mapState } from 'vuex';
export default {
  name: 'GivingSection',
  components: {
    Pill,
  },
  methods: {
    busScheduleWebView() {
      FirebaseAnalytics.logEvent({
        name: 'click_button',
        params: {
          button_name: 'useful-links-shuttle-bus-schedule',
          page: 'home',
        },
      });
      Browser.open({
        url: this.$t('copy.homePage.mainLayout.usefulLinks.links.busSchedulePdf'),
      });
    },
  },
  computed: {
    ...mapState('profile', ['email']),
  },
};
</script>

<style></style>
